import GoogleMap from "../../common/google-map";
import * as style from "./office-info.module.scss";
import ContactBox from "../../common/contact-box";
import * as React from "react";

const OfficeInfo = () => {
    return (
        <div className="row g-4 row-cols-1 row-cols-lg-3 pb-4">
            <div className="col bg-monochromatic text-white p-5 rounded"
                 data-sal="flip-left" data-sal-delay="300" data-sal-easing="ease-in-sine" data-sal-duration="300">
                <h2 className="pb-3">Godziny otwarcia</h2>
                <div>
                    <div className="row border-bottom">
                        <div className="col">Poniedziałek</div>
                        <div className="col">9:00-20:00</div>
                    </div>
                    <div className="row border-bottom">
                        <div className="col">Wtorek</div>
                        <div className="col">9:00-20:00</div>
                    </div>
                    <div className="row border-bottom">
                        <div className="col">Środa</div>
                        <div className="col">9:00-20:00</div>
                    </div>
                    <div className="row border-bottom">
                        <div className="col">Czwartek</div>
                        <div className="col">9:00-20:00</div>
                    </div>
                    <div className="row border-bottom">
                        <div className="col">Piątek</div>
                        <div className="col">9:00-20:00</div>
                    </div>
                </div>
            </div>
            <div className="col" data-sal="flip-down" data-sal-delay="400" data-sal-easing="ease-in-sine" data-sal-duration="400">
                <GoogleMap height="600" />
            </div>
            <div className={style.contactBox + " col bg-primary text-white p-5 rounded"}
                 data-sal="flip-right" data-sal-delay="200" data-sal-easing="ease-in-sine" data-sal-duration="300">
                <ContactBox />
            </div>
        </div>
    );
}

export default OfficeInfo